import { render } from "./createJournalH5.vue?vue&type=template&id=5f440432&scoped=true"
import script from "./createJournalH5.vue?vue&type=script&lang=js"
export * from "./createJournalH5.vue?vue&type=script&lang=js"

import "./createJournalH5.vue?vue&type=style&index=0&id=5f440432&lang=less&scoped=true"

import exportComponent from "/devops/jenkins_new/jenkins02-node1/workspace/Record_web_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f440432"]])

export default __exports__